const CARTO_BASEMAPS_API_KEY = process.env.PUBLIC_CARTO_BASEMAPS_API_KEY || '';
const cartoTileUrl = (path) =>
  `https://{s}.basemaps.cartocdn.com/${path}/{z}/{x}/{y}{r}.png${
    CARTO_BASEMAPS_API_KEY ? `?key=${CARTO_BASEMAPS_API_KEY}` : ''
  }`;

export const STREET_TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const STREET_TILE_ATTRIBUTION =
  '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
export const CARTO_TILE_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';
export const VOYAGER_TILE_URL = cartoTileUrl('rastertiles/voyager');
export const DARK_TILE_URL = cartoTileUrl('dark_all');

export const MAP_STYLE_OPTIONS = [
  { value: 'default', label: 'Default' },
  { value: 'monochrome', label: 'Monochrome' },
  { value: 'enhancedContrast', label: 'Enhanced Contrast' },
  { value: 'highContrast', label: 'High Contrast' },
  { value: 'defaultDark', label: 'Default (Dark)' },
  { value: 'voyager', label: 'Voyager' },
  { value: 'voyagerDark', label: 'Voyager (Dark)' },
  { value: 'dark', label: 'Dark' },
];

export const DEFAULT_MAP_OPTIONS = {
  darkMode: false,
  mapStyle: 'default',
};

const TILE_STYLE_CONFIG = {
  default: {
    url: STREET_TILE_URL,
    attribution: STREET_TILE_ATTRIBUTION,
    className: undefined,
    darkMode: false,
  },
  monochrome: {
    url: STREET_TILE_URL,
    attribution: STREET_TILE_ATTRIBUTION,
    className: 'fusion-map-monochrome-tiles',
    darkMode: true,
  },
  enhancedContrast: {
    url: VOYAGER_TILE_URL,
    attribution: CARTO_TILE_ATTRIBUTION,
    className: undefined,
    darkMode: false,
  },
  highContrast: {
    url: VOYAGER_TILE_URL,
    attribution: CARTO_TILE_ATTRIBUTION,
    className: undefined,
    darkMode: false,
  },
  voyager: {
    url: VOYAGER_TILE_URL,
    attribution: CARTO_TILE_ATTRIBUTION,
    className: undefined,
    darkMode: false,
  },
  voyagerDark: {
    url: VOYAGER_TILE_URL,
    attribution: CARTO_TILE_ATTRIBUTION,
    className: 'fusion-map-dark-tiles',
    darkMode: true,
  },
  defaultDark: {
    url: STREET_TILE_URL,
    attribution: STREET_TILE_ATTRIBUTION,
    className: 'fusion-map-dark-tiles',
    darkMode: true,
  },
  dark: {
    url: DARK_TILE_URL,
    attribution: CARTO_TILE_ATTRIBUTION,
    className: undefined,
    darkMode: true,
  },
};

export const normalizeMapOptions = (mapOptionsOrDarkMode = DEFAULT_MAP_OPTIONS) => {
  if (typeof mapOptionsOrDarkMode === 'boolean') {
    return {
      ...DEFAULT_MAP_OPTIONS,
      darkMode: mapOptionsOrDarkMode,
      mapStyle: mapOptionsOrDarkMode ? 'voyagerDark' : 'default',
    };
  }

  if (!mapOptionsOrDarkMode || typeof mapOptionsOrDarkMode !== 'object') {
    return { ...DEFAULT_MAP_OPTIONS };
  }

  const fallbackStyle = mapOptionsOrDarkMode.darkMode
    ? 'voyagerDark'
    : DEFAULT_MAP_OPTIONS.mapStyle;
  const mapStyle = TILE_STYLE_CONFIG[mapOptionsOrDarkMode.mapStyle]
    ? mapOptionsOrDarkMode.mapStyle
    : fallbackStyle;

  return {
    ...DEFAULT_MAP_OPTIONS,
    mapStyle,
    darkMode: TILE_STYLE_CONFIG[mapStyle].darkMode,
  };
};

export const getStreetTileLayerConfig = (mapOptionsOrDarkMode = false) => {
  const normalizedMapOptions = normalizeMapOptions(mapOptionsOrDarkMode);
  const styleConfig = TILE_STYLE_CONFIG[normalizedMapOptions.mapStyle] || TILE_STYLE_CONFIG.default;

  return {
    ...styleConfig,
    mapStyle: normalizedMapOptions.mapStyle,
    containerClassName: styleConfig.darkMode ? 'fusion-map-dark-ui' : undefined,
  };
};
